export default {
  common: {
    welcome: 'Welcome',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    yes: 'Yes',
    no: 'No',
    id: 'ID',
    created_at: 'Created at',
    noDescription: 'No description',
    rowsPerPage: 'Rows per page:',
    noResults: 'No results found',
    noData: 'No data registered',
    unknown: 'Unknown',
    user: 'User',
    notifications: 'Notifications',
  },
  theme: {
    light: 'Light mode',
    dark: 'Dark mode',
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    loginButton: 'Sign In',
    invalidCredentials: 'Invalid credentials',
    loginSuccess: 'Login successful',
    logoutSuccess: 'Logout successful',
  },
  menu: {
    dashboard: 'Dashboard',
    groups: 'Groups',
    companies: 'Companies',
    users: 'Users',
    sessions: 'Sessions',
    logs: 'Logs',
    config: 'Settings',
    systemGalatea: 'Galatea System',
    dicionarioDados: 'Data Dictionary',
    dicionarioThor: 'Thor Dictionary',
  },
  groups: {
    title: 'Company Groups',
    new: 'New Group',
    edit: 'Edit Group',
    name: 'Name',
    description: 'Description',
    uuid: 'UUID',
    generateUuid: 'Generate new UUID',
    enforceLimit: 'Enforce concurrent access limit',
    enforceLimitShort: 'Enforce limit?',
    enforceLimitHint: 'Enable to restrict the number of simultaneous sessions per user across the group companies.',
    limitPerUser: 'Sessions limit per user',
    limitPerUserHint: 'Leave empty for unlimited. Provide an integer greater than or equal to zero.',
    limitPerUserPositive: 'The limit must be an integer greater than or equal to zero.',
    limitUnlimited: 'Unlimited',
    permissiveLimit: 'Allow exceeding limit in special cases',
    permissiveLimitShort: 'Permissive?',
    permissiveLimitHint: 'When enabled, the system allows surpassing the defined limit under controlled scenarios.',
    createSuccess: 'Group created successfully!',
    updateSuccess: 'Group updated successfully!',
    deleteSuccess: 'Group deleted successfully!',
    deleteConfirm: 'Are you sure you want to delete this group?',
    deleteWarning: 'This action cannot be undone.',
    searchPlaceholder: 'Search by name or description...',
    noResults: 'No groups found',
    noData: 'No groups registered',
  },
  companies: {
    title: 'Companies',
    new: 'New Company',
    edit: 'Edit Company',
    name: 'Name',
    cnpj: 'CNPJ',
    database: 'Database',
    ip: 'IP/Host',
    group: 'Group',
    status: 'Status',
    createSuccess: 'Company created successfully!',
    updateSuccess: 'Company updated successfully!',
    deleteSuccess: 'Company deleted successfully!',
    deleteConfirm: 'Are you sure you want to delete this company?',
    deleteWarning: 'This action cannot be undone.',
    searchPlaceholder: 'Search by name, CNPJ or database...',
    noResults: 'No companies found',
    noData: 'No companies registered',
  },
  users: {
    title: 'Users',
    edit: 'Edit User',
    name: 'Name',
    email: 'Email',
    accessLevel: 'Access Level',
    updateSuccess: 'User updated successfully!',
    linkCompanies: 'Manage Companies',
    linkCompaniesTitle: 'Manage Companies - {{name}}',
    linkedCompanies: 'Linked Companies',
    availableCompanies: 'Available Companies',
    link: 'Link',
    unlink: 'Unlink',
    noLinkedCompanies: 'No linked companies',
    allLinked: 'All companies are already linked',
    searchPlaceholder: 'Search by name or email...',
    noResults: 'No users found',
    noData: 'No users registered',
    emailCannotBeChanged: 'Email cannot be changed',
    userActive: 'User Active',
  },
  sessions: {
    title: 'User Sessions',
    selectUser: 'Select a user',
    activeSessions: 'Active Sessions',
    activeSessionsCount: 'Active Sessions: {{valid}} of {{total}}',
    deviceId: 'Device ID',
    deviceName: 'Device Name',
    expiresAt: 'Expires at',
    createdAt: 'Created at',
    revoke: 'Revoke',
    revokeAll: 'Revoke All',
    revokeSuccess: 'Session revoked successfully!',
    revokeAllSuccess: 'All sessions have been revoked!',
    valid: 'Valid',
    revoked: 'Revoked',
    noSessions: 'No sessions found',
  },
  accessLevels: {
    superAdmin: 'Super Administrator',
    administrator: 'Administrator',
    manager: 'Manager',
    supervisor: 'Supervisor',
    operator: 'Operator',
    defaultUser: 'Default User',
  },
  context: {
    selectTitle: 'Select Mode of Operation',
    selectSubtitle: 'Choose how you want to act in the system',
    changeTitle: 'Change Context of Operation',
    modeOfAction: 'Mode of Operation',
    superAdmin: 'Super Administrator',
    superAdminDescription: 'Full system access (management of groups, companies, backups, global settings)',
    administrator: 'Administrator',
    administratorDescription: 'Administrative access in a specific company (select the company)',
    user: 'Company User',
    userDescription: 'Access as a regular user of a specific company',
    company: 'Company',
    companyRequired: 'Company *',
    selectCompany: 'Select a company',
    noCompanyAvailable: 'No company available for selection.',
    continue: 'Continue',
    changeContext: 'Change Context',
    selectMode: 'Select a mode of operation',
    selectCompanyError: 'Select a company',
    saveError: 'Error saving context',
    loadError: 'Error loading user context',
    changeLanguage: 'Change language',
    switchContextTooltip: 'Change context of operation',
  },
  config: {
    title: 'Settings',
    subtitle: 'Choose a configuration module to continue.',
    appearanceTitle: 'Appearance',
    appearanceSubtitle: 'Choose the visual theme and the light/dark mode.',
    options: {
      appearance: {
        title: 'Appearance',
        description: 'Choose visual theme and light/dark mode.',
      },
      branding: {
        title: 'Branding',
        description: 'Header logo and background watermark.',
      },
      system: {
        title: 'System Parameters',
        description: 'Manage global configuration for the Galatea platform (coming soon).',
        comingSoon: 'Coming soon',
      },
      dicionario: {
        title: 'Thor Documentation',
        description: 'Browse and maintain the documentation for Thor databases tables and columns.',
      },
      open: 'Open',
    },
    sistemaGalatea: {
      title: 'Galatea System',
      subtitle:
        'This area is under development. Soon you will be able to manage Galatea platform core resources here.',
    },
    dicionarioThor: {
      title: 'Thor Documentation',
      subtitle: 'Review the documented columns from the Thor databases.',
      searchPlaceholder: 'Search by table, column or description...',
      error: 'Error while loading dictionary data.',
      empty: 'No records found.',
      table: 'Table',
      column: 'Column',
      type: 'Type',
      length: 'Length',
      decimals: 'Decimals',
      statusColumn: 'Status',
      description: 'Description',
      tableFilter: 'Table filter',
      tablePlaceholder: 'e.g. clis, alternativas',
      columnFilter: 'Column filter',
      columnPlaceholder: 'e.g. cdcliente, dscoluna',
    },
  },
  themePresets: {
    'galatea-navy': { name: 'Galatea Navy', recommendation: 'General Administration' },
    'emerald-warehouse': { name: 'Emerald Warehouse', recommendation: 'WMS / Inventory' },
    'taxation-gold': { name: 'Taxation Gold', recommendation: 'Tax / ICMS / IPI' },
    'bpa-cyber': { name: 'BPA Cyber', recommendation: 'Automation & AI' },
    'slate-industrial': { name: 'Slate Industrial', recommendation: 'Long-running Operations' },
    'deep-oceanic': { name: 'Deep Oceanic', recommendation: 'Logistics & Freight' },
    'ruby-accounting': { name: 'Ruby Accounting', recommendation: 'Finance / Audit' },
    'amber-logistics': { name: 'Amber Logistics', recommendation: 'Shipping / Tracking' },
    'nordic-frost': { name: 'Nordic Frost', recommendation: 'Management Reports' },
    'midnight-tech': { name: 'Midnight Tech', recommendation: 'Dev Mode / Power Users' },
    'coffee-bean': { name: 'Coffee Bean', recommendation: 'Procurement & Supplies' },
    'vibrant-violet': { name: 'Vibrant Violet', recommendation: 'CRM & Sales' },
    'forest-edge': { name: 'Forest Edge', recommendation: 'Sustainability' },
    'electric-blue': { name: 'Electric Blue', recommendation: 'Real-time Monitoring' },
    'sunset-orange': { name: 'Sunset Orange', recommendation: 'Risk Management' },
    'steel-grey': { name: 'Steel Grey', recommendation: 'General Master Data' },
    'teal-serenity': { name: 'Teal Serenity', recommendation: 'HR & Workforce' },
    'royal-purple': { name: 'Royal Purple', recommendation: 'Executive Dashboards' },
    'clay-terracotta': { name: 'Clay Terracotta', recommendation: 'Shop Floor' },
    'high-contrast': { name: 'High Contrast', recommendation: 'Accessibility / Low Vision' },
  },
  unidades: {
    title: 'Units of Measure',
    code: 'Code',
    codePlaceholder: 'Code',
    codeHint: 'Code (PK - e.g. KG, MT, PC)',
    codeRequired: 'Code is required',
    description: 'Description',
    descriptionPlaceholder: 'Unit Description',
    descriptionHint: 'Description / Name',
    descriptionRequired: 'Description is required',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    casasDecimais: 'Decimal Places',
    casasDecimaisHint: 'Decimal Places (0-4)',
    unidadeNfe: 'NFE Unit',
    unidadeNfeHint: 'NFE Unit (Sefaz)',
    unidadeNfePlaceholder: 'UN, KG, M2, etc.',
    refUnit: 'Reference Unit',
    refUnitPlaceholder: 'None (Base Unit)',
    refUnitHint: 'Reference Unit (Optional)',
    fatorHint: 'Reference Ratio (Factor)',
    fatorLabel: 'Reference Table Ratio',
    fatorPlaceholder: '1.000000',
    exportExcel: 'Excel',
    exportExcelSuccess: 'Data exported to Excel!',
    inativar: 'Inactivate',
    inativarSuccess: 'Unit inactivated!',
    inativarAlready: 'Unit is already inactive',
    inativarConfirm: 'Inactivate unit "{{code}} — {{description}}"?',
    saveSuccess: 'Record saved successfully!',
    createSuccess: 'Record created successfully!',
    updateSuccess: 'Record updated successfully!',
    loadError: 'Error loading data',
    noEmpresa: 'No company selected',
    newTitle: 'New Unit of Measure',
    editTitle: 'Editing: {{code}}'
  }
}
